<app-modal-card>
  @if (imageUrl()) {
    <img [src]="imageUrl()" alt="" class="size-[68px] object-cover shrink-0" />
  }

  <p class="text-[19px] font-semibold fg-noir-1 text-center mt-[28px]">{{ title() }}</p>

  @if (highlightText()) {
    <p class="text-[19px] font-semibold fg-vert-1 text-center mt-[15px]">{{ highlightText() }}</p>
  }

  @if (subtitle()) {
    <p class="text-[14px] fg-gris-1 text-center mt-[12px]">{{ subtitle() }}</p>
  }

  <ng-content></ng-content>

  @if (countdownText()) {
    <p class="text-[14px] fg-gris-1 italic text-center mt-[70px]">{{ countdownText() }}</p>
  }

  @if (buttonLabel()) {
    <button
      type="button"
      class="mt-[60px] w-[400px] h-[58px] flex items-center justify-center bg-white border border-solid border-gris-3 rounded-[5px] text-[16px] font-semibold fg-noir-2 cursor-pointer"
      (click)="buttonClick.emit()"
    >
      {{ buttonLabel() }}
    </button>
  }
</app-modal-card>
